<div class="searchBarCalendar__container-calendar" [class.show]="showCalendar" [class.is-hotel-detail]="isHotelDetail">
  <div class="searchBarCalendar__background-calendar" [class.show]="showCalendar" (click)="close()"></div>
  <app-ds-background-surface *ngIf="showCalendar"
    class="searchBarCalendar__cont"
    [width]="'792px'"
    [height]="'592px'"
    [position]="'absolute'"
    [borderRadius]="'var(--border-radius-nano)'">
    <ng-container *ngIf="showCalendar">
      <div class="searchBarCalendar__cont__date-calendar">
        <app-ds-date-calendar
          [inputsLabel]="{ left: departurePlaceholder, right: returnPlaceholder }"
          [inputsPlaceholder]="{ left: departurePlaceholder, right: returnPlaceholder }"
          [defaultField]="fieldActivated"
          [isOnlyOneDate]="isOneWayTrip"
          [scrollToDefaultDate]="true"
          [translate]="translate"
          [allowSameDateSelection]="allowTheSameDay"
          [defaultDates]="defaultDates"
          [minDate]="minDate"
          [locale]="localeByLanguage"
          (selectEvent)="selectEvent($event)"
          (emitPosition)="translateEvent($event)">
            <app-calendar-inputs
              [searchType]="searchType"
              [flightType]="flightTypeCalendar"
              (selectFlightType)="selectFlightType($event)">
            </app-calendar-inputs>
        </app-ds-date-calendar>
      </div>
      <div class="searchBarCalendar__cont__apply-button">
        <app-ds-button
          [isDisabled]="!isValidDateCalendar"
          [labels]="{ ButtonLabel: daysBetweenTwoDatesLabel | transloco : { days: daysBetweenTwoDates } }"
          (clickEvent)="toggleShow(false)">
        </app-ds-button>
      </div>
    </ng-container>
  </app-ds-background-surface>
</div>
